import Sms from './Index.vue';

export const routes = [
  {
    path: 'sms',
    name: 'talkvia_sms',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: Sms,
  },
];
